import React, {PureComponent, CSSProperties} from 'react'
import PropTypes from 'prop-types'
import cxs from 'cxs/component'
import Theme, {mediaQueries} from 'Theme'
import {Rules} from 'helpers/Validation'
import {
  FieldCheckbox,
  FieldDate,
  FieldTime,
  FieldImage,
  FieldInput,
  FieldSelect,
  FieldTextArea
} from 'elements'
import FieldIcon from './FieldIcon'

interface Props {
  field: IField
  onChange(
    name: string,
    value: any | string | string[] | boolean | Date | File | null ,
    column?: string | null
  ): void
}

class Field extends PureComponent<Props, object> {
  renderField() {
    const {field, onChange} = this.props
    const value = field.value || ''
    // console.log('Field - render - field: ', field)
    // console.log('Field - render - field.value: ', field.value)
    // console.log('Field - render - field.type: ', field.type)
    const required = (field.rules && field.rules.isRequired) || false
    switch (field.type) {
      case FieldType.Text:
      case FieldType.Number:
      case FieldType.Password:
        return (
          <FieldInput
            type={field.type}
            name={field.name}
            column={field.column}
            value={value as string}
            required={required}
            onChange={onChange}
          />
        )
      case FieldType.TextArea:
        return (
          <FieldTextArea
            type={field.type}
            name={field.name}
            column={field.column}
            value={value as string}
            required={required}
            onChange={onChange}
          />
        )
      case FieldType.Checkbox:
        return (
          <FieldCheckbox
            type={field.type}
            name={field.name}
            column={field.column}
            value={value as boolean}
            required={required}
            onChange={onChange}
          />
        )
      case FieldType.Image:
        return (
          <FieldImage
            name={field.name}
            column={field.column}
            value={value as string}
            footer={field.footer}
            accept={field.accept}
            onChange={onChange}
          />
        )
      case FieldType.Select:
        return field.options ? (
          <FieldSelect
            name={field.name}
            column={field.column}
            value={value as string}
            options={field.options}
            placeholder={field.placeholder}
            required={required}
            onChange={onChange}
          />
        ) : null
      case FieldType.Date:
        return (
          <FieldDate
            name={field.name}
            column={field.column}
            date={value as Date}
            required={required}
            onChange={onChange}
          />
        )
      case FieldType.DateTime:
        return (
          <FieldDate
            name={field.name}
            column={field.column}
            date={value as Date}
            withTime
            required={required}
            onChange={onChange}
          />
        )
      case FieldType.Time:
        return (
          <FieldTime
            name={field.name}
            column={field.column}
            hora={value}
            required={required}
            onChange={onChange}
          />
        )
      case FieldType.Icon:
        return (
          <FieldIcon
            icon={value as string}
            icons={field.icons!}
            onChange={onChange}
          />
        )
      default:
        return null
    }
  }

  render() {
    const {field} = this.props
    return <Wrapper size={field.size}>{this.renderField()}</Wrapper>
  }
}

export default Field

export interface IField {
  name: string
  value?: string | string[] | object[] | boolean | Date | number | any
  defaultValue?: string | string[] | object[] | boolean | Date | number | any
  type: FieldType
  placeholder?: string
  rules?: Rules
  options?: {name: string; value: string | undefined}[]
  size?: number /** [1..9] = 10% to 90% */
  id?: number
  column?: string
  icons?: string[]
  footer?: string
  typeImage?: string
  accept?: string
}

export const FieldType = {
  Checkbox: 'checkbox',
  Date: 'date',
  DateTime: 'dateTime',
  Time: 'time',
  Icon: 'icon',
  Image: 'image',
  Number: 'number',
  Password: 'password',
  Select: 'select',
  Text: 'text',
  TextArea: 'textarea',
  MultiSelect: 'multiSelect'
}

export type FieldType = string

const Wrapper = cxs('div')(({size}) => ({
  padding: '0.1px', // TEMP: Fix collapsing margin
  [mediaQueries.desktop]: {
    display: 'flex',
    flex: `1 1 ${(size || 10) * 10}%`,
    alignItems: 'flex-end',
    '> div': {
      flex: 1
    }
  } as CSSProperties
}))

Wrapper.propTypes = {
  size: PropTypes.number
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/elements/Field.tsx